import { Vue, Component, Emit } from 'vue-property-decorator'
import JobConfigurationServices from '@/api/resources/configuration/peopleManagement/job/JobConfigurationServices'
import { Nullable } from '@/shared/types/app.types'
import { initialStatisticalAnalysisFilterByState, StatisticalAnalysisFilterByEnum, StatisticalAnalysisFilterByState, StatisticalAnalysisFilterByStateCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-filter-by/statistical-analysis-filter-by.model'
import { statisticalAnalysisTimesheetService } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.service'
import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'

@Component
export default class StatisticalAnalysisFilterBy extends Vue {
    state: StatisticalAnalysisFilterByState
    @Emit()
    changeFilterBy(value: Nullable<StatisticalAnalysisFilterByStateCombo>): Nullable<StatisticalAnalysisFilterByStateCombo> {
        return value
    }
    @Emit()
    changeFilter(value: Nullable<StatisticalAnalysisFilterByStateCombo>): Nullable<StatisticalAnalysisFilterByStateCombo> {
        return value
    }
    @Emit()
    changeTimeSheetFilter(value: Nullable<StatisticalAnalysisTimesheetItems>): Nullable<StatisticalAnalysisTimesheetItems> {
        return value
    }
    constructor() {
        super()
        this.state = initialStatisticalAnalysisFilterByState()
    }

    get isLoading(): boolean {
        return this.state.loading
    }

    created() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    async mounted() {
        await this._getTimesheets()
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    getTranslatedLabel(item: StatisticalAnalysisFilterByStateCombo): string {
        return this.$tc(item.text)
    }

    async onChangeFilterBy(selection: Nullable<StatisticalAnalysisFilterByStateCombo>): Promise<void> {
        switch (selection?.id) {
        case StatisticalAnalysisFilterByEnum.JOB:
            this.changeFilterBy(selection)
            const [error, response] = await this.$_toCall(JobConfigurationServices.getJobs())
            if (error) {
                this._resetFilter()
            } else {
                this.state.filter.list = response.map((item: any) => {
                    return {
                        id: item.id,
                        text: item.translatedName
                    }
                })
            }
            break
        case StatisticalAnalysisFilterByEnum.SKILL:
            // TODO In the first version it is not included
            break
        default:
            this._resetFilter()
            this.changeFilter(null)
        }
    }

    onChangeFilter(value: Nullable<StatisticalAnalysisFilterByStateCombo>): void {
        this.changeFilter(value)
    }

    onChangeTimeSheetFilter(value: Nullable<StatisticalAnalysisTimesheetItems>): void {
        this.changeTimeSheetFilter(value)
    }

    private _resetFilter(): void {
        this.state.filter.list = []
        this.state.filter.selected = null
    }

    private async _getTimesheets(): Promise<void> {
        this.state.loading = true
        const [err, response] = await this.$_toCall(statisticalAnalysisTimesheetService.getTimesheets())
        if (err) {
            this.changeTimeSheetFilter(null)
        } else {
            this.state.filterTimeSheet.list = response
            const selected = response?.[0]
            this.state.filterTimeSheet.selected = selected
            this.changeTimeSheetFilter(selected)
        }
        this.state.loading = false
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.loading = value
    }
}
